import React, { useMemo, useState } from 'react';
import InvoiceInfo from '../InvoiceInfo/InvoiceInfo';
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable';

function InvoiceListView({ invoiceList, isLoading }) {

    const schedules = invoiceList?.schedules || [];

    const columns = useMemo(() => [
        { title: "#", key: "key" },
        { key: 'ScheduleCode', title: 'Schedule Code' },
        { key: 'AssignedFSE', title: 'Assigned FSE' },
        { key: 'ManDays', title: 'Man Days' },
        { key: 'StartDate', title: 'Start Date' },
        { key: 'EndDate', title: 'End Date' }
    ], []);

    // Map the schedule data into table rows
    const rows = () => schedules?.map((item, index) => ({
        key: index + 1,
        id: item.InvoicesID,
        ScheduleCode: item.ScheduleCode,
        AssignedFSE: item?.AssignedFSE,
        ManDays: item?.ManDays,
        StartDate: item?.StartDate,
        EndDate: item?.EndDate,
    }));

    const ClientName = () => {
        return schedules?.map((item => item.ClientName || 'N/A'))
    }
    return (
        <>
            <InvoiceInfo invoiceData={invoiceList?.invoice} ClientName={ClientName()} />

            <div className='top-container'>
                <CustomTable
                    columns={columns}
                    rows={isLoading ? [] : rows()}
                    isCheckbox={false}
                    isLoading={isLoading}
                />
            </div>
        </>
    );
}

export default InvoiceListView;
